import '../App.css';
import Advantages from './Advantages';
import HeroSection from './HeroSection';
import HowWork from './HowWork';
import Mission from './Mission';
import CallToAction from './HeroSection/components/CallToAction';

function Home() {
  return (
    <div className="App">
      <div className='page'>
        <HeroSection />
        <HowWork />
        <Mission />
        <Advantages />
        <CallToAction />
      </div>
    </div>
  );
}

export default Home;